export const mutations = {
  setCache(state, { title, isCached, language }) {
    if (language) {
      state.videos[language][title].isCached = isCached;
    } else {
      state.videos.default[title].isCached = isCached;
    }
  },
  setCachingError(state, hasFailed) {
    state.failedCache = hasFailed;
  },
  setIsCachingElements(state, isCahing) {
    state.isCachingElements = isCahing;
  },
  setIsDeletingElements(state, isDeleting) {
    state.isDeletingElements = isDeleting;
  },
  incrementLoadedElements(state) {
    state.loadedElements += 1;
  },
  resetLoadedElementsAndSumOfElements(state) {
    state.loadedElements = 0;
    state.sumElementsToLoad = 0;
  },
  setSumElementsToLoad(state, { sumOfElements }) {
    state.sumElementsToLoad = sumOfElements;
  },
  setLanguageCached(state, { language, isCached }) {
    if (language === "en") {
      state.enIsCached = isCached;
    } else {
      state.deIsCached = isCached;
    }
  },
  incrementDeletedElements(state) {
    state.deletedElements += 1;
  },
  resetDeletedElementsAndSumOdElements(state) {
    state.deletedElements = 0;
    state.sumElementsToDelete = 0;
  },
  setSumOfElementsToDelete(state, sumOfElements) {
    state.sumElementsToDelete = sumOfElements;
  },
  setLanguage(state, language) {
    if (state.language !== language) {
      state.language = language;
    }
  },
  setPwaMode(state) {
    state.isPwaModeActive =
      process.env.VUE_APP_MODE === "Offline" ? true : false;
  },
  setIsCheckingCachedElements(state, value) {
    state.isCheckingCachedElements = value;
  },
  setIsSettingsModalopen(state, value){
    state.isSettingsModalopen = value;
  },
  setIsSarsModalVisible(state, value) {
    state.isSarsModalVisible = value;
  }
};
